import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

import { FormFeedback } from 'app/components/ui/form/FormFeedback'
import { Flex } from 'app/components/ui/Flex'

import sendIcon from 'static/icons/send.svg'

interface Props {
  onConfirm: (email: string) => void
}

const NewsletterForm: React.FC<Props> = ({ onConfirm }) => {
  const [email, setEmail] = useState('')
  const [isTouched, setIsTouched] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!email) {
      setError('Inserisci la tua email')
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      setError('Indirizzo email non valido')
    } else {
      setError(null)
    }
  }, [email])

  const handleSubmit = () => {
    if (error) {
      return
    }
    onConfirm(email)
  }

  return (
    <form
      onSubmit={e => {
        e.preventDefault()
        handleSubmit()
      }}
    >
      <Flex flexDirection='column'>
        <FormGroup>
          <Input
            value={email}
            onChange={({ currentTarget: { value } }) => setEmail(value)}
            onBlur={({ currentTarget: { value } }) => {
              if (value) {
                setIsTouched(true)
              }
            }}
            placeholder='Inserisci la tua email'
          />
          <Button
            className='btn-send'
            onClick={() => {
              setIsTouched(true)
            }}
          >
            <img src={sendIcon} alt='send newsletter' />
          </Button>
        </FormGroup>
        {isTouched && error ? (
          <FormFeedback variant='error'>{error}</FormFeedback>
        ) : null}
      </Flex>
    </form>
  )
}

export default NewsletterForm

const FormGroup = styled.div`
  display: flex;
  border-radius: 20px;
  width: 100%;

  &:focus-within {
    box-shadow: 0px 0px 3px 0px
      ${props => props.theme.color.secondari.cianoChiaro};
  }
`

const Input = styled.input`
  flex: 1;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  height: 40px;
  padding-right: 1rem;
  border: 0;
  margin: 0;
  padding: 0.5rem 2rem 0.5rem 1rem;
  :focus {
    outline: none;
  }
`

const Button = styled.button`
  width: 86px;
  border-radius: 20px;
  margin: 0 0 0 -1.5rem;
  border-color: transparent;
  background-color: ${props => props.theme.color.primari.ciano};
  transition: background-color 0.15s ease-in-out;
  cursor: pointer;

  :hover {
    /* emulating color as it was with opacity 0.9 */
    /* since with opacity there's input bg on its back that overlaps transparency */
    background-color: #38b8ff;
  }

  &:focus {
    outline: none;
  }
`
